<div class="app-es-ocr-quick-fix-bl-details">
  <div class="app-es-ocr-quick-fix-bl-details__header">
    <div class="app-es-ocr-quick-fix-bl-details__header__left">
      <p class="app-es-ocr-quick-fix-bl-details__header__title">
        {{ "LABELS.BILL_OF_LADING_DETAILS" | translate | uppercase }}
      </p>
      <app-hint-tooltip-icon
        [hint]="isRail ? ('INFO.BL.SUB_TITLE_RAIL' | translate) : ('ENTRY_SUMMARY.SCAC_HINT' | translate)"
      ></app-hint-tooltip-icon>
    </div>
  </div>

  <p
    class="app-es-ocr-quick-fix-bl-details__text"
    [innerHTML]="isRail ? ('INFO.BL.SUB_TITLE_RAIL' | translate) : ('ENTRY_SUMMARY.SCAC_HINT' | translate)"
  ></p>

  <div class="app-es-ocr-quick-fix-bl-details__row">
    <!--Master SCAC-->
    <app-section-form-block-layout
      *ngIf="!!masterScacFields"
      [formGroup]="formGroup"
      [headerTitle]="billOfLadingData.carrier.titleMaster"
      headerTitleClass="md-weight"
      sectionClass="no-gap"
      [infoTooltip]="billOfLadingData.carrier.tooltip"
      [fields]="masterScacFields"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [fieldErrorCallback]="formFieldError"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(masterScacFields)"
      editBlockClass="normal-gap"
      [isShowEditBlockLabel]="false"
      [isHideBorder]="true"
    ></app-section-form-block-layout>
    <!--Master Bl-->
    <app-section-form-block-layout
      *ngIf="!!masterBlFields"
      [formGroup]="formGroup"
      [headerTitle]="billOfLadingData.number.titleMaster"
      headerTitleClass="md-weight"
      sectionClass="no-gap"
      [infoTooltip]="billOfLadingData.number.tooltip"
      [fields]="masterBlFields"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(masterBlFields)"
      editBlockClass="normal-gap"
      [isShowEditBlockLabel]="false"
      [isHideBorder]="true"
    ></app-section-form-block-layout>
  </div>

  <div class="app-es-ocr-quick-fix-bl-details__row" *ngIf="!isRail && !isTruck">
    <!--House SCAC-->
    <app-section-form-block-layout
      *ngIf="!!houseScacFields"
      [formGroup]="formGroup"
      [headerTitle]="billOfLadingData.carrier.titleHouse"
      headerTitleClass="md-weight"
      sectionClass="no-gap"
      [infoTooltip]="billOfLadingData.carrier.tooltip"
      [fields]="houseScacFields"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(houseScacFields)"
      editBlockClass="normal-gap"
      [isShowEditBlockLabel]="false"
      [isHideBorder]="true"
    ></app-section-form-block-layout>
    <!--House Bl-->
    <app-section-form-block-layout
      *ngIf="!!houseBlFields"
      [formGroup]="formGroup"
      [headerTitle]="billOfLadingData.number.titleHouse"
      headerTitleClass="md-weight"
      sectionClass="no-gap"
      [infoTooltip]="billOfLadingData.number.tooltip"
      [fields]="houseBlFields"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(houseBlFields)"
      editBlockClass="normal-gap"
      [isShowEditBlockLabel]="false"
      [isHideBorder]="true"
    ></app-section-form-block-layout>
  </div>

  <p class="app-es-ocr-quick-fix-bl-details__text">
    {{ "ENTRY_SUMMARY.FILL_TOTAL_QUANTITY" | translate }}
  </p>

  <div class="app-es-ocr-quick-fix-bl-details__row">
    <!--Quantity-->
    <app-section-form-block-layout
      *ngIf="!!quantityFields"
      [formGroup]="formGroup"
      headerTitle="FORM_LABEL.TOTAL_QUANTITY"
      headerTitleClass="md-weight"
      sectionClass="md-gap"
      [fields]="[quantityFields[0]]"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty([quantityFields[0]])"
      editBlockClass="normal-gap"
      [isShowEditBlockLabel]="false"
      [isHideBorder]="true"
    ></app-section-form-block-layout>

    <!--Quantity Units-->
    <app-section-form-block-layout
      *ngIf="!!quantityFields"
      [formGroup]="formGroup"
      headerTitle="FORM_LABEL.UNIT_OF_MEASURE"
      headerTitleClass="md-weight"
      sectionClass="md-gap"
      [fields]="[quantityFields[1]]"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty([quantityFields[1]])"
      editBlockClass="normal-gap"
      [isShowEditBlockLabel]="false"
      [isHideBorder]="true"
    ></app-section-form-block-layout>
  </div>

  <div class="app-es-ocr-quick-fix-bl-details__section" *ngIf="isImmediateTransfer">
    <p class="app-es-ocr-quick-fix-bl-details__text">
      <span class="mr-2" [innerHTML]="'ENTRY_SUMMARY.FILL_IMMEDIATE_TRANSFER' | translate"></span>
      <app-hint-tooltip-icon [hint]="'ENTRY_SUMMARY.FILL_IMMEDIATE_TRANSFER' | translate"></app-hint-tooltip-icon>
    </p>

    <div class="app-es-ocr-quick-fix-bl-details__row">
      <!--IT Number-->
      <app-section-form-block-layout
        *ngIf="!!itFields"
        [formGroup]="formGroup"
        headerTitle="FORM_LABEL.IT_NUMBER"
        headerTitleClass="md-weight"
        sectionClass="md-gap"
        [fields]="[itFields[0]]"
        [displayErrors]="displayErrors"
        [formErrors]="formErrors"
        [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty([itFields[0]])"
        editBlockClass="normal-gap"
        [isShowEditBlockLabel]="false"
        [isHideBorder]="true"
      ></app-section-form-block-layout>

      <!--IT Date-->
      <app-section-form-block-layout
        *ngIf="!!itFields"
        [formGroup]="formGroup"
        headerTitle="FORM_LABEL.IT_DATE"
        headerTitleClass="md-weight"
        sectionClass="md-gap"
        [fields]="[itFields[1]]"
        [displayErrors]="displayErrors"
        [formErrors]="formErrors"
        [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty([itFields[1]])"
        editBlockClass="normal-gap"
        [isShowEditBlockLabel]="false"
        [isHideBorder]="true"
      ></app-section-form-block-layout>
    </div>
  </div>

  <missing-fields [code]="'LABELS.ENTRY_SUMMARY'" (decline)="onSubmit(false)"></missing-fields>
</div>
